const features = {
  SUPPORTS_CONTENT_MANAGEMENT: 'SupportsContentManagement',
  SUPPORTS_STUDENT_OUTREACH: 'SupportsStudentOutreach',
  SUPPORTS_PERSONALIZED_MESSAGES: 'SupportsPersonalizedMessages',
  SUPPORTS_STUDENT_ANALYTICS: 'SupportsStudentAnalytics',
  SUPPORTS_USER_UPLOADED_SEGMENTS: 'SupportsUserUploadedSegments',
  APPLICATION_INTEGRATION: 'ApplicationIntegration',
  APPLICATION_ACTIVATION: 'ApplicationActivation',
  CRM_INTEGRATION: 'CrmIntegration',
  SUPPORTS_PREMIUM_MATCH_MESSAGING: 'SupportsPremiumMatchMessaging',
  BYPASS_SLATE_APP_ROUND_VERIFICATION: 'BypassSlateAppRoundVerification',
  SUPPORTS_PREMIUM_HIGH_SCHOOL_EXPLORER: 'SupportsPremiumHighSchoolExplorer',
  SUPPORTS_RACE_AND_ETHNICITY_SEGMENTATION: 'SupportsRaceAndEthnicitySegmentation',
  SUPPORTS_SUBJECT_TEST_SEGMENTATION: 'SupportsSubjectTestSegmentation',
  SUPPORTS_HANDRAISERS: 'SupportsStudentInterestSharing',
  SUPPORTS_PARENT_HANDRAISERS: 'SupportsParentInterestSharing',
  SUPPORTS_GRANULAR_MEDIAN_INCOME: 'SupportsGranularMedianIncome',
  SUPPORTS_LIMITED_AUTOMATED_MESSAGES: 'SupportsLimitedAutomatedStudentOutreach',
  SUPPORTS_CAMPUS_ESP: 'supportsCampusESP',
}

export default features
